export const SET_EVENTS = 'SET_EVENTS';
export const SET_NO_MORE_EVENT = 'SET_NO_MORE_EVENT';
export const APPEND_EVENTS = 'APPEND_EVENTS';
export const SET_EVENT_FILTERS = 'SET_EVENT_FILTERS';
export const SET_EVENT_NOTIFICATIONS = 'SET_EVENT_NOTIFICATIONS';
export const SET_EVENT_STATE = 'SET_EVENT_STATE';
export const SET_NOTIFICATION_AS_READ = 'SET_NOTIFICATION_AS_READ';
export const SET_READ_EVENT_NOTIFICATIONS = 'SET_READ_EVENT_NOTIFICATIONS';